<h2>Welcome {{ userData?.fullName }}</h2>
<p>You have been invited to join {{ tenantConfigService.config.productName }}. Please choose a password.</p>
<p class="no-margin">Your Email Address</p>
<p class="strong_style">{{ userData?.email }}</p>

<form class="password-form" [formGroup]="invitationSignUpFormGroup">
  <input type="text" name="username" autocomplete="username" [value]="userData?.email" style="display: none" />
  <div>
    <hfc-text-input
      type="password"
      placeholder="Enter password"
      autocomplete="new-password"
      class="input"
      formControlName="password"
    ></hfc-text-input>
  </div>

  <div>
    <hfc-text-input
      type="password"
      placeholder="Re-enter password"
      autocomplete="new-password"
      class="input"
      formControlName="confirmPassword"
    ></hfc-text-input>
  </div>
  <hfc-password-requirements [control]="invitationSignUpFormGroup.get('password')"></hfc-password-requirements>

  <div
    *ngIf="invitationSignUpFormGroup.errors?.nomatch && invitationSignUpFormGroup.get('confirmPassword').value"
    class="text-red validation-error"
  >
    Passwords don't match
  </div>
</form>
